import { UiSchema } from '@rjsf/utils'

import { calculateLFMeasurementOfMaterial } from '../imup/sagas/2D/createDrawableLocation'
import { FormProperties } from '../imup/types'
import { ActiveDrawable } from '../models/activeDrawable'
import { GeneralDrawableSettings } from '../models/activeDrawableSettings'
import { DRAWABLE_TYPES } from '../shared/constants/drawable-types'
import { convertFullNumberFractionToDecimal, truncateToDecimals } from '../utils/formSchema/numberConversion'

const pitchOtherValue = 'other'

export const hipRooflineType = 'Hip'
export const valleyRoofLineType = 'Valley'
const ridgeLineType = 'Ridge'

const uiSchema: UiSchema = {
    'ui:order': ['type', 'selection', 'pitch1', 'pitch1_other', 'pitch2', 'pitch2_other'],
    type: {
        'ui:placeholder': 'Select Type',
    },
    selection: {
        'ui:placeholder': 'Select Roofing',
    },
}

const onSubmit = (settings, formData) => {
    const newSettings = { ...settings, ...formData }

    if (newSettings.pitch1 === pitchOtherValue && newSettings.pitch1_other) {
        newSettings.pitch1 =
            convertFullNumberFractionToDecimal(String(newSettings.pitch1_other)) ?? newSettings.pitch1_other
        newSettings.pitch1 = truncateToDecimals(newSettings.pitch1)

        delete newSettings.pitch1_other
    } else if (newSettings.pitch1 !== pitchOtherValue) {
        newSettings.pitch1_other = null
    }

    if (newSettings.pitch2 === pitchOtherValue && newSettings.pitch2_other) {
        newSettings.pitch2 =
            convertFullNumberFractionToDecimal(String(newSettings.pitch2_other)) ?? newSettings.pitch2_other
        newSettings.pitch2 = truncateToDecimals(newSettings.pitch2)

        delete newSettings.pitch2_other
    } else if (newSettings.pitch2 !== pitchOtherValue) {
        newSettings.pitch2_other = null
    }

    if (formData.type === ridgeLineType) {
        newSettings.pitch1 = null
        newSettings.pitch2 = null
    }

    return newSettings
}

const onValidate = () => {}

/**
 * Augment the drawables of the from based on the new settings
 * @param drawables the drawables in the group
 * @param newSettings the new group settings
 * @param scaleFactor the scaleFactor of the page
 * @returns
 */
function prepareDrawables(input: {
    drawables: ActiveDrawable[]
    newSettings: GeneralDrawableSettings
    scaleFactor: number
}): ActiveDrawable[] {
    const { drawables, newSettings } = input

    return drawables.map((drawable) => {
        drawable.settings.quantity = calculateLFMeasurementOfMaterial(drawable.settings.linear_total, {
            type: DRAWABLE_TYPES.ROOF_LINE,
            settings: newSettings,
        })

        return drawable
    })
}

const form: FormProperties = { uiSchema, onValidate, onSubmit, prepareDrawables }

export default form
